import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { getLanguageFromUrl } from 'shared/helpers/parseUrl';
import { Key } from 'i18n/Key';

import en from 'i18n/translations/en.json';
import fr from 'i18n/translations/fr.json';
import ja from 'i18n/translations/ja.json';
import ro from 'i18n/translations/ro.json';
import zhcn from 'i18n/translations/zhcn.json';
import ru from 'i18n/translations/ru.json';
import bg from 'i18n/translations/bg.json';
import cs from 'i18n/translations/cs.json';
import id from 'i18n/translations/id.json';
import ko from 'i18n/translations/ko.json';
import nl from 'i18n/translations/nl.json';
import th from 'i18n/translations/th.json';
import vi from 'i18n/translations/vi.json';
import el from 'i18n/translations/el.json';
import uk from 'i18n/translations/uk.json';
import by from 'i18n/translations/by.json';
import es from 'i18n/translations/es.json';
import de from 'i18n/translations/de.json';
import pt from 'i18n/translations/pt.json';

export const DEFAULT_NS = 'translation';
export const DEFAULT_LANG = 'en';

const resources = {
  en: {
    [DEFAULT_NS]: en,
  },
  fr: {
    [DEFAULT_NS]: fr,
  },
  ja: {
    [DEFAULT_NS]: ja,
  },
  ro: {
    [DEFAULT_NS]: ro,
  },
  zhcn: {
    [DEFAULT_NS]: zhcn,
  },
  ru: {
    [DEFAULT_NS]: ru,
  },
  bg: {
    [DEFAULT_NS]: bg,
  },
  cs: {
    [DEFAULT_NS]: cs,
  },
  id: {
    [DEFAULT_NS]: id,
  },
  ko: {
    [DEFAULT_NS]: ko,
  },
  nl: {
    [DEFAULT_NS]: nl,
  },
  th: {
    [DEFAULT_NS]: th,
  },
  vi: {
    [DEFAULT_NS]: vi,
  },
  uk: {
    [DEFAULT_NS]: uk,
  },
  el: {
    [DEFAULT_NS]: el,
  },
  by: {
    [DEFAULT_NS]: by,
  },
  es: {
    [DEFAULT_NS]: es,
  },
  de: {
    [DEFAULT_NS]: de,
  },
  pt: {
    [DEFAULT_NS]: pt,
  },
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: getLanguageFromUrl(),
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    escapeValue: false,
  },
});

export const addDefaultTranslates = (
  trans: { [key in keyof typeof Key]?: string },
) => {
  const defaultTrans = i18n.getResourceBundle(DEFAULT_LANG, DEFAULT_NS);
  Object.entries(trans).forEach(([key, img]) => {
    if (!defaultTrans[img])
      i18n.addResources(DEFAULT_LANG, DEFAULT_NS, { [key]: img });
  });
};
